import React from "react";

const ChessEventCard = () => {
  return (
    <div className="max-w-3xl mx-auto p-4  shadow-xl rounded-2xl">
      <divider>----------------------</divider>
      <p>Next</p>
      <divider>----------------------</divider>
      <h1 className="text-2xl font-bold mb-2">1st Eastleigh FIDE Congress</h1>
      <p className="text-gray-600 mb-1">
        <strong>Dates:</strong> Saturday, June 28th @ 10:00 am – Sunday, June
        29th @ 6:00 pm
      </p>
      <div className="mt-3 space-y-2">
        <p>
          <strong>Type:</strong> 5-round Swiss StandardPlay Tournament
        </p>
        <p>
          <strong>Sections:</strong> Open, U1850, U1550
        </p>
        <p>
          <strong>Ratings:</strong> FIDE & ECF Rated
        </p>
        <p>
          <strong>Time Control:</strong> 60 minutes + 30 seconds increment from
          start
        </p>
        <p>
          <strong>Membership:</strong> ECF Gold required or Pay-to-Play fee
        </p>
      </div>
      <div className="mt-4">
        <h2 className="font-semibold">Venue</h2>
        <p>
          Barton Peveril College @ Chestnut Avenue, Eastleigh South, United
          Kingdom
        </p>
        <p className="text-sm text-gray-500">
          ~20 min walk from Southampton Airport Parkway & Eastleigh Train
          Station. Direct buses from Romsey & Southampton. Free parking
          available.
        </p>
      </div>
      <div className="mt-4">
        <h2 className="font-semibold">Online Entry</h2>
        <a
          href="https://congress.org.uk/congress/542/home"
          className="text-blue-600 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Register Online
        </a>
      </div>
      {/*  */}
      <div className="mt-6 text-sm text-gray-500">
        <p>
          <strong>Tags:</strong> Congress, London, South East, South West,
          Standardplay
        </p>
        <p>
          <strong>Categories:</strong> BCC Qualifier, ECF Rated, FIDE Rated,
          Partly Disability Friendly
        </p>
      </div>
      <div className="mt-4">
        <h2 className="font-semibold">Add to Calendar</h2>
      </div>
    </div>
  );
};

export default ChessEventCard;
